import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheLongevityFrontier from "./sections/TheLongevityFrontier";
import RealTimeMarketPulse from "./sections/RealTimeMarketPulse";
import CreativeVectors from "./sections/CreativeVectors";
import OurStory from "./sections/OurStory";
import TheBrewingRitual from "./sections/TheBrewingRitual";
import BringTraditionToYourTable from "./sections/BringTraditionToYourTable";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheLongevityFrontier />
      <RealTimeMarketPulse />
      <CreativeVectors />
      <OurStory />
      <TheBrewingRitual />
      <BringTraditionToYourTable />
      <Footer />
    </div>;
}